/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f8a5b1d52c87c4ebf0f8d754ced7b55c4503e8dd";
